import { render, staticRenderFns } from "./KitEdit.vue?vue&type=template&id=504309b1"
import script from "./KitEdit.vue?vue&type=script&lang=js"
export * from "./KitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports